module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Eschenbach_SG_COA-6ec7b3bf4463e13b5a93c5fa37cd9ba6.svg";